import { LoaderFunctionArgs } from 'react-router'
import { QueryClient } from '@tanstack/react-query'
import { projectRouterKeys } from 'src/api/routes/project'
import { client } from '../api/axios'
import { Project } from 'src/types/projects'
import { useTenantStore } from '../store/tenentStore'

export async function atlasLoader(_args: LoaderFunctionArgs) {
  const selectedTenantId = useTenantStore.getState().currentTenant?.id
  if (!selectedTenantId) return null

  const queryClient = new QueryClient()
  await queryClient.prefetchQuery({
    queryKey: [projectRouterKeys.atlas, selectedTenantId],
    queryFn: async () => {
      const response = await client.get<Project[]>(`/tenants/${selectedTenantId}/projects:atlas`)
      return response.data
    },
  })
  return null
}
